import { render, staticRenderFns } from "./DropdownItem.vue?vue&type=template&id=08f3d0fd&scoped=true"
import script from "./DropdownItem.vue?vue&type=script&lang=ts"
export * from "./DropdownItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f3d0fd",
  null
  
)

export default component.exports